export const useStyles = () => {
    return {
        switch: {
            marginLeft: 0,
            gap: 2
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
    }
}